const IMAGES = {
    GROUND: require('src/assets/images/ground.png'),
    HOME: require('src/assets/images/home.png'),
    MY_PROFILE: require('src/assets/images/my-profile.png'),
    SEARCH: require('src/assets/images/search.png'),
    TEAM_PROFILE: require('src/assets/images/team-profile.png'),
    LOGO: require('src/assets/images/logo.png'),
    FOOTER_LOGO: require('src/assets/images/footer-logo.png'),


};

export default IMAGES;
